module.exports = __webpack_public_path__ + "ME.png?7054be129ae60672589abb795e0dccb6";